import { styled } from '@clickcease/cc-client-components-lib'

export const InputContainer = styled('div', {
  position: 'relative',
  '& > :first-child > :nth-child(3)': {
    maxHeight: '350px',
    overflow: 'auto',
  },
})

export const InputError = styled('div', {
  color: '$error',
  fontWeight: '$l',
  fontSize: '$sm',
  position: 'absolute',
  bottom: '-20px',
  left: '0px',
})
